import React from "react";
import { connect } from "react-redux";
import Schemes from "./schemes/Schemes";
import Groups from "./groups/Groups";
import AddScheme from "./schemes/AddScheme";
import AddGroup from "./groups/AddGroup";
import Letters from "./letters/Letters";
import InvalidPermissions from "../company-pages/InvalidPermissions";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import EmployeePensions from "./employees/EmployeePensions";

const tabs = [
	{
		link: "/organisation/pension/employees",
		name: "Employees",
	},
	{
		link: "/organisation/pension/schemes",
		name: "Schemes",
	},
	{
		link: "/organisation/pension/groups",
		name: "Groups",
	},
	{
		link: "/organisation/pension/letters",
		name: "Letters",
	},
];

const Pension = ({ permissions }) => {
	const location = useLocation();
	const currentTab = location.pathname;
	if (permissions) return <InvalidPermissions />;

	return (
		<>
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Pensions</h1>
						</div>
					</div>
				</div>
				<AddScheme />
				<AddGroup />
			</div>
			<div className="content bg-white">
				<ul className="nav nav-tabs nav-tabs alt nav-justified">
					{tabs.map((tab) => {
						return (
							<li className={currentTab === tab.link ? "active" : ""}>
								<Link to={tab.link}>{tab.name}</Link>
							</li>
						);
					})}
				</ul>
			</div>
			<div className="mb-32">
				<Routes>
					<Route
						path="/employees"
						element={<EmployeePensions />}
					/>
					<Route
						path="/schemes"
						element={<Schemes />}
					/>
					<Route
						path="/groups"
						element={<Groups />}
					/>
					<Route
						path="/letters"
						element={<Letters />}
					/>
					<Route
						path="*"
						element={
							<Navigate
								to="/organisation/pension/employees"
								replace
							/>
						}
					/>
				</Routes>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		permissions: state?.permissions?.my?.permissions?.pensions == "None",
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Pension);
